import { alertAnatomy } from '@chakra-ui/anatomy';
import { createMultiStyleConfigHelpers } from '@chakra-ui/react';

const { definePartsStyle, defineMultiStyleConfig } =
  createMultiStyleConfigHelpers(alertAnatomy.keys);

const primaryVariant = definePartsStyle((props) => {
  const { colorScheme: c } = props;

  return {
    container: {
      px: '3',
      py: '3',
      bg: `${c}.25`,
      borderColor: `${c}.50`,
      borderWidth: 'thin',
      borderRadius: 'xl',
      justifyContent: 'space-between',
    },
    icon: {
      color: `${c}.500`,
      flexShrink: 0,
      marginEnd: '3',
      rounded: 'full',
      fontSize: '2xl',
      w: '9',
      h: '9',
    },
    title: {
      fontWeight: 'semibold',
    },
    description: {
      color: 'gray.600',
    },
  };
});

export const alertTheme = defineMultiStyleConfig({
  variants: { '@primary': primaryVariant },
  defaultProps: {
    colorScheme: 'success',
  },
});
